module.exports = __webpack_public_path__ + "static/media/18.b9dab3f2.jpg";